import { render } from "./VerifyEmailRequest.vue?vue&type=template&id=0f08a9be"
import script from "./VerifyEmailRequest.vue?vue&type=script&lang=js"
export * from "./VerifyEmailRequest.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/khatoncollection-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__